/**
 * 墨 · 阅读 - 主应用入口
 */

import {
  initDB,
  addBook,
  getBook,
  getAllBooks,
  updateBook,
  deleteBook,
  updateBooksOrder,
  addThought,
  updateThought,
  getAllThoughts,
  deleteThought,
  addHighlight,
  getAllHighlights,
  updateHighlight,
  deleteHighlight,
  addEssay,
  getAllEssays,
  updateEssay,
  deleteEssay,
  saveReadingProgress,
  getReadingProgress,
  addBookmark,
  getAllBookmarks,
  deleteBookmark,
  addMusic,
  getAllMusic,
  updateMusic,
  deleteMusic,
  addPodcast,
  getAllPodcasts,
  updatePodcast,
  deletePodcast
} from './db/database.js';
import {
  loadCategories as loadCategoriesFromStorage,
  saveCategories as saveCategoriesToStorage,
  loadCollections as loadCollectionsFromStorage,
  saveCollections as saveCollectionsToStorage,
  loadBooklists as loadBooklistsFromStorage,
  saveBooklists as saveBooklistsToStorage,
  loadGlobalShelfOrder as loadGlobalShelfOrderFromStorage,
  saveGlobalShelfOrder as saveGlobalShelfOrderToStorage,
  updateGlobalShelfOrderForCollectionOrder as updateGlobalShelfOrderForCollectionOrderInStorage,
  generateCollectionId as generateCollectionIdValue,
  generateBooklistId as generateBooklistIdValue
} from './features/shelfStorageModule.js';
import {
  showToast as showToastFromModule
} from './features/toastModule.js';
import {
  escapeHtml
} from './features/htmlSecurityModule.js';
import {
  initEnhancedFeaturesLifecycle,
  cleanupEnhancedFeaturesLifecycle
} from './features/readerEnhancementsLifecycleModule.js';
import {
  createChunkRecovery
} from './features/chunkRecoveryModule.js';
import {
  formatRelativeDateZh
} from './features/dateFormatModule.js';
import {
  buildMixedShelfItems as buildMixedShelfItemsHelper
} from './features/bookshelfRenderHelpersModule.js';
import {
  updateBookshelfDragState as updateBookshelfDragStateFromModule
} from './features/bookshelfDragStateModule.js';
import {
  createInitialState,
  collectAppElements
} from './features/appStateElementsModule.js';
import {
  initAppLifecycle,
  loadAllDataForApp
} from './features/appBootstrapModule.js';
import {
  initPageScrollbar as initPageScrollbarFromModule,
  setupWindowControlsOverlay as setupWindowControlsOverlayFromModule
} from './features/pageUiSetupModule.js';
import {
  syncUnifiedSearchUi as syncUnifiedSearchUiFromModule,
  renderBookshelfView as renderBookshelfViewFromModule
} from './features/shelfRenderOrchestrationModule.js';
import {
  removeBooksFromAllCollections as removeBooksFromAllCollectionsFromModule,
  removeBooksFromAllBooklists as removeBooksFromAllBooklistsFromModule,
  addBooksToCollection as addBooksToCollectionFromModule
} from './features/shelfMembershipModule.js';
import {
  toggleSortMenuByElements,
  handleSortByWithUi
} from './features/shelfSortInteractionModule.js';
import {
  createShelfPresentationFacade
} from './features/shelfPresentationFacadeModule.js';
import {
  createShelfStorageActionFacade
} from './features/shelfStorageActionFacadeModule.js';
import {
  createReaderConstructorResolver
} from './features/readerConstructorResolver.js';
import {
  renderCurrentViewByName,
  renderBooklistViewWithLazyInit,
  renderThoughtsViewWithLazyInit,
  renderHighlightsViewWithLazyInit
} from './features/viewRenderModule.js';
import {
  waitForStableElementSizeFallback,
  clearTocSearchFallback,
  toggleTocFallback,
  bindReaderOverlayOutsideCloseFallback as bindReaderOverlayOutsideCloseFallbackFromModule,
  togglePanelFallback,
  closeAllPanelsFallback
} from './features/readerUiFallbackModule.js';
import {
  createReaderAnnotationToolbarBridge
} from './features/readerAnnotationToolbarBridgeModule.js';
import {
  createReaderSettingsBridge
} from './features/readerSettingsBridgeModule.js';
import {
  createAiOrchestrator
} from './features/aiOrchestratorModule.js';
import {
  initMembershipModule,
  canAccessFeature as canAccessMembershipFeature,
  getBookLimit as getMembershipBookLimit,
  openMembershipCenter as openMembershipCenterPanel,
  isCurrentUserAdmin as isCurrentMembershipAdmin
} from './features/membershipModule.js';
import {
  initAdminDashboardModule,
  renderAdminDashboardView
} from './features/adminDashboardModule.js';
import {
  createMusicOrchestrator
} from './features/musicOrchestratorModule.js';
import {
  createSettingsOrchestrator
} from './features/settingsOrchestratorModule.js';
import {
  createReaderOrchestrator
} from './features/readerOrchestratorModule.js';
import {
  createShelfOrchestrator
} from './features/shelfOrchestratorModule.js';
import {
  createAiDomainRuntime
} from './features/aiDomainRuntimeModule.js';
import {
  createMusicDomainRuntime
} from './features/musicDomainRuntimeModule.js';
import {
  createSettingsDomainRuntime
} from './features/settingsDomainRuntimeModule.js';
import {
  createShelfUiDomainRuntime
} from './features/shelfUiDomainRuntimeModule.js';
import {
  createShelfUiActionFacade
} from './features/shelfUiActionFacadeModule.js';
import {
  createReaderDomainRuntime
} from './features/readerDomainRuntimeModule.js';
import {
  createReaderUiActionFacade
} from './features/readerUiActionFacadeModule.js';
import {
  createLibraryFeatureRuntime
} from './features/libraryFeatureRuntimeModule.js';
import {
  createLibraryUiActionFacade
} from './features/libraryUiActionFacadeModule.js';
import {
  createCoreUiRuntime
} from './features/coreUiRuntimeModule.js';
import {
  createCoreUiActionFacade
} from './features/coreUiActionFacadeModule.js';


// 增强功能实例
let autoScroll = null;
let tts = null;
let readingTimer = null;
let textSearch = null;
let gestures = null;
let immersiveMode = null;
let autoNightMode = null;
// Kept in main scope to avoid runtime ReferenceError in openModal after modal logic split.
let activeCategoryEditMenuCleanup = null;
let shelfUiActions = null;
let readerUiActions = null;
let libraryUiActions = null;
let coreUiActions = null;
let shelfOrchestrator = null;
const formatDate = (dateStr) => formatRelativeDateZh(dateStr);
const showToast = (message) => showToastFromModule(message);
const {
  importWithChunkRecovery,
  installChunkLoadRecoveryHandlers,
  triggerChunkLoadRecovery
} = createChunkRecovery({
  showToast: (message) => showToast(message)
});
const getReaderConstructor = createReaderConstructorResolver(importWithChunkRecovery);

// ========================================
// 全局状态
// ========================================
const state = createInitialState();

// ========================================
// DOM 元素
// ========================================
const elements = collectAppElements(document);
const canAccessFeature = (featureName) => canAccessMembershipFeature(state, featureName);
const getBookLimit = () => getMembershipBookLimit(state);
const openMembershipCenter = () => openMembershipCenterPanel();
const isAdmin = () => isCurrentMembershipAdmin(state);
const shelfPresentationFacade = createShelfPresentationFacade({
  state,
  escapeHtml
});
const {
  getBooklistBookCount,
  createCollectionCardHtml,
  createCollectionListItemHtml,
  createBooklistActionCardHtml,
  createBooklistActionListItemHtml,
  filterBooks,
  sortBooksForBooklist,
  sortBooklists,
  sortBooks,
  sortCollections,
  getFilteredCollectionsForShelf,
  getNextCustomSortOrder,
  createBookCard,
  createBookListItem,
  buildCollectionShelfHeaderHtml
} = shelfPresentationFacade;
const shelfStorageActions = createShelfStorageActionFacade({
  getShelfOrchestrator: () => shelfOrchestrator
});
const {
  loadCategories,
  saveCategories,
  loadCollections,
  saveCollections,
  loadBooklists,
  saveBooklists,
  loadGlobalShelfOrder,
  saveGlobalShelfOrder,
  updateGlobalShelfOrderForCollectionOrder,
  generateCollectionId,
  generateBooklistId,
  removeBooksFromAllCollections,
  removeBooksFromAllBooklists,
  addBooksToCollection
} = shelfStorageActions;
const showAddBooklistModal = (...args) => libraryUiActions?.showAddBooklistModal(...args);
const showAllCategoriesModal = (...args) => libraryUiActions?.showAllCategoriesModal(...args);
const showAddCategoryModal = (...args) => libraryUiActions?.showAddCategoryModal(...args);
const showEditCategoryMenu = (...args) => libraryUiActions?.showEditCategoryMenu(...args);
const showAllBooklistsModal = (...args) => libraryUiActions?.showAllBooklistsModal(...args);
const showManageBooklistBooksModal = (...args) => libraryUiActions?.showManageBooklistBooksModal(...args);
const showEditBooklistMenu = (...args) => libraryUiActions?.showEditBooklistMenu(...args);
const showAllCollectionsModal = (...args) => libraryUiActions?.showAllCollectionsModal(...args);
const showAddCollectionModal = (...args) => libraryUiActions?.showAddCollectionModal(...args);
const showEditCollectionMenu = (...args) => libraryUiActions?.showEditCollectionMenu(...args);
const showBatchCollectionModal = (...args) => libraryUiActions?.showBatchCollectionModal(...args);
const showBookDetail = (...args) => libraryUiActions?.showBookDetail(...args);
const handleFileSelect = async (...args) => libraryUiActions?.handleFileSelect(...args);
const handleDrop = async (...args) => libraryUiActions?.handleDrop(...args);
const syncThoughtsScrollbarGutter = () => {
  const thoughtsView = document.getElementById('thoughtsView');
  const timeline = elements.thoughtsTimeline;
  if (!thoughtsView || !timeline) return;
  const gutter = Math.max(0, timeline.offsetWidth - timeline.clientWidth);
  thoughtsView.style.setProperty('--thoughts-scrollbar-gutter', `${gutter}px`);
};
const getThoughtsCallbacks = () => ({
  addThought,
  deleteThought,
  updateThought,
  showToast,
  formatDate,
  openThoughtModal
});
const bindAiLazyEntrypoints = () => aiOrchestrator.bindLazyEntrypoints();
const initPageScrollbar = () => initPageScrollbarFromModule();
const setupWindowControlsOverlay = () => setupWindowControlsOverlayFromModule(syncThemeColor);
const setupSiteThemeLongPressFullscreen = () => settingsOrchestrator.setupSiteThemeLongPressFullscreen();
const setupEventListeners = () => coreUiActions?.setupEventListeners();
const setupEnhancedReaderEvents = () => invokeReaderControlsPanel('setupEnhancedReaderEvents');
const syncUnifiedSearchUi = () => syncUnifiedSearchUiFromModule(state, elements);
const switchView = (...args) => shelfUiActions?.switchView(...args);
const updatePrimaryActionButton = () => shelfUiActions?.updatePrimaryActionButton();
const handlePrimaryActionClick = () => shelfUiActions?.handlePrimaryActionClick();
const loadShelfViewMode = () => shelfUiActions?.loadShelfViewMode();
const updateShelfViewModeButton = () => shelfUiActions?.updateShelfViewModeButton();
const setViewMode = (...args) => shelfUiActions?.setViewMode(...args);
const setupBookshelfDelegatedEvents = () => coreUiActions?.setupBookshelfDelegatedEvents();
const setupFormatEvents = () => shelfUiActions?.setupFormatEvents();
const updateFormatFilters = () => shelfUiActions?.updateFormatFilters();
const setupCategoryEvents = () => shelfUiActions?.setupCategoryEvents();
const renderCategoryFilters = () => shelfUiActions?.renderCategoryFilters();
const renderCollectionFilters = () => shelfUiActions?.renderCollectionFilters();
const updateShelfStats = () => shelfUiActions?.updateShelfStats();
const updateWelcomeMessage = (forceNew = false) => shelfUiActions?.updateWelcomeMessage(forceNew);
const updateRecentTimeline = () => shelfUiActions?.updateRecentTimeline();
const loadReadingStats = () => readerUiActions?.loadReadingStats();
const startReadingSession = () => readerUiActions?.startReadingSession();
const endReadingSession = () => readerUiActions?.endReadingSession();
const handleSearch = (...args) => shelfUiActions?.handleSearch(...args);
const clearSearch = () => shelfUiActions?.clearSearch();
const enterSelectMode = () => shelfUiActions?.enterSelectMode();
const exitSelectMode = () => shelfUiActions?.exitSelectMode();
const toggleBookSelection = (...args) => shelfUiActions?.toggleBookSelection(...args);
const deleteSelectedBooks = async (...args) => shelfUiActions?.deleteSelectedBooks(...args);
const showBatchCategoryModal = () => shelfUiActions?.showBatchCategoryModal();
const waitForStableElementSize = async (...args) => readerUiActions?.waitForStableElementSize(...args);
const rerenderReaderForCurrentSize = () => readerUiActions?.rerenderReaderForCurrentSize();
const maybeFixInitialRenderSize = async (...args) => readerUiActions?.maybeFixInitialRenderSize(...args);
const applyMobileReaderImmersive = () => readerUiActions?.applyMobileReaderImmersive();
const openBook = async (...args) => readerOrchestrator.openBook(...args);
const openBookAtLocation = async (...args) => readerOrchestrator.openBookAtLocation(...args);
const closeReader = () => readerOrchestrator.closeReader();
const navigatePage = async (...args) => readerOrchestrator.navigatePage(...args);
const updateProgressDisplay = () => readerOrchestrator.updateProgressDisplay();
const loadToc = async (...args) => readerOrchestrator.loadToc(...args);
const toggleToc = () => readerOrchestrator.toggleToc();
const handleTocSearch = async (...args) => readerOrchestrator.handleTocSearch(...args);
const clearTocSearch = () => readerOrchestrator.clearTocSearch();
const setupReaderOverlayOutsideCloseEvents = () => readerOrchestrator.setupReaderOverlayOutsideCloseEvents();
const togglePanel = (...args) => readerOrchestrator.togglePanel(...args);
const closeAllPanels = () => readerOrchestrator.closeAllPanels();
const changeFontSize = (...args) => readerSettingsBridge.changeFontSize(...args);
const changeLineHeight = (...args) => readerSettingsBridge.changeLineHeight(...args);
const changeFontFamily = (...args) => readerSettingsBridge.changeFontFamily(...args);
const changeTheme = (...args) => readerSettingsBridge.changeTheme(...args);
const applyReaderSettings = () => readerSettingsBridge.applyReaderSettings();
const loadReaderSettings = () => readerSettingsBridge.loadReaderSettings();
const loadSiteTheme = () => settingsOrchestrator.loadSiteTheme();
const toggleSiteTheme = () => settingsOrchestrator.toggleSiteTheme();
const syncModalOverlayTheme = () => settingsOrchestrator.syncModalOverlayTheme();
const syncThemeColor = () => settingsOrchestrator.syncThemeColor();
const toggleFullscreen = () => readerUiActions?.toggleFullscreen();
const openQuickThought = () => readerUiActions?.openQuickThought();
const setupSelectionToolbar = () => readerAnnotationToolbarBridge.setupSelectionToolbar();
const handleHighlight = async (...args) => readerAnnotationToolbarBridge.handleHighlight(...args);
const bindIframeSelectionEvents = () => readerAnnotationToolbarBridge.bindIframeSelectionEvents();
const restoreSavedMarks = () => readerAnnotationToolbarBridge.restoreSavedMarks();
const hideSelectionToolbar = () => readerAnnotationToolbarBridge.hideSelectionToolbar();
const openThoughtModal = (...args) => coreUiActions?.openThoughtModal(...args);
const createNewEssay = async (...args) => coreUiActions?.createNewEssay(...args);
const handleEssayTitleChange = () => coreUiActions?.handleEssayTitleChange();
const deleteCurrentEssay = async (...args) => coreUiActions?.deleteCurrentEssay(...args);
const toggleEssaysSidebar = () => coreUiActions?.toggleEssaysSidebar();
const renderEssays = () => coreUiActions?.renderEssays();
const openModal = () => coreUiActions?.openModal();
const closeModal = () => coreUiActions?.closeModal();
const initModalDrag = () => coreUiActions?.initModalDrag();
const toggleDualPageMode = () => readerUiActions?.toggleDualPageMode();
const initResizeHandler = () => readerUiActions?.initResizeHandler();
const cleanupResizeHandler = () => readerUiActions?.cleanupResizeHandler();
const addCurrentBookmark = async (...args) => readerUiActions?.addCurrentBookmark(...args);
const renderBookmarks = () => readerUiActions?.renderBookmarks();
const showShareHighlightModal = async (...args) => readerUiActions?.showShareHighlightModal(...args);
const confirmDeleteBook = (...args) => coreUiActions?.confirmDeleteBook(...args);
const handleKeyboard = (...args) => readerUiActions?.handleKeyboard(...args);
const initThoughtsMobileSidebarToggleBridge = () => coreUiActions?.initThoughtsMobileSidebarToggleBridge();
const renderMusic = () => musicOrchestrator.renderMusic();
const renderAdmin = () => renderAdminDashboardView();
const updateBookshelfDragState = () => updateBookshelfDragStateFromModule(state, elements);
const toggleSortMenu = (menuEl) => toggleSortMenuByElements(menuEl, elements);
const showShortcutsHint = () => {};
const showReadingEstimate = () => {};

const aiDomainRuntime = createAiDomainRuntime({
  importWithChunkRecovery,
  state,
  elements,
  showToast,
  escapeHtml,
  canAccessFeature,
  openMembershipCenter
});
const {
  ensureAiModuleReady,
  getAiModuleApi
} = aiDomainRuntime;

const musicDomainRuntime = createMusicDomainRuntime({
  importWithChunkRecovery,
  state,
  elements,
  showToast,
  formatDate,
  openModal,
  closeModal,
  addMusic,
  updateMusic,
  deleteMusic,
  addPodcast,
  updatePodcast,
  deletePodcast,
  canAccessFeature,
  openMembershipCenter
});
const {
  ensureMusicPlayerReady
} = musicDomainRuntime;

const settingsDomainRuntime = createSettingsDomainRuntime({
  importWithChunkRecovery,
  state,
  elements,
  showToast
});
const {
  ensureSiteThemeModuleReady,
  ensureSiteThemeFullscreenModuleReady,
  getSiteThemeModuleApi,
  getSiteThemeFullscreenModuleApi
} = settingsDomainRuntime;

const libraryFeatureRuntime = createLibraryFeatureRuntime({
  importWithChunkRecovery,
  state,
  elements,
  showToast,
  formatDate,
  openModal,
  closeModal,
  deleteHighlight,
  updateHighlight,
  openBookAtLocation,
  showShareHighlightModal,
  syncUnifiedSearchUi,
  showEditBooklistMenu,
  showAllBooklistsModal,
  confirmDeleteBook,
  showBookDetail,
  openBook,
  saveBooklists,
  updateShelfViewModeButton,
  updatePrimaryActionButton,
  generateBooklistId,
  sortBooksForBooklist,
  sortBooklists,
  createBooklistActionCardHtml,
  createBooklistActionListItemHtml,
  createBookCard,
  createBookListItem,
  saveCategories,
  saveCollections,
  renderBookshelf,
  renderCollectionFilters,
  updateBook,
  generateCollectionId,
  escapeHtml,
  renderCategoryFilters,
  renderBooklistView,
  renderCurrentView,
  switchView,
  showAddBooklistModal,
  getBooklistBookCount,
  updateGlobalShelfOrderForCollectionOrder,
  addBooksToCollection,
  exitSelectMode,
  ensureMusicPlayerReady,
  getReaderConstructor,
  addBook,
  getNextCustomSortOrder,
  canAccessFeature,
  getBookLimit,
  openMembershipCenter
});
const {
  ensureHighlightsModuleReady,
  getHighlightsModuleApi,
  isHighlightsModuleEventsBound,
  ensureBooklistModuleReady,
  getBooklistModuleApi,
  ensureBookDetailModuleReady,
  ensureLibraryModalsModuleReady,
  ensureFileImportModuleReady
} = libraryFeatureRuntime;

libraryUiActions = createLibraryUiActionFacade({
  ensureBooklistModuleReady,
  ensureLibraryModalsModuleReady,
  ensureBookDetailModuleReady,
  ensureFileImportModuleReady,
  showToast
});

const readerDomainRuntime = createReaderDomainRuntime({
  importWithChunkRecovery,
  state,
  elements,
  showToast,
  openModal,
  closeModal,
  addHighlight,
  updateHighlight,
  deleteHighlight,
  addCurrentBookmark,
  togglePanel,
  closeAllPanels,
  toggleDualPageMode,
  getTextSearch: () => textSearch,
  getTts: () => tts,
  getAutoScroll: () => autoScroll,
  getReadingTimer: () => readingTimer,
  syncModalOverlayTheme,
  syncThemeColor,
  loadSiteTheme,
  updateProgressDisplay,
  clearTocSearch,
  saveReadingProgress,
  updateBook,
  getBook,
  getReadingProgress,
  getReaderConstructor,
  waitForStableElementSize,
  loadToc,
  applyReaderSettings,
  maybeFixInitialRenderSize,
  showShortcutsHint,
  startReadingSession,
  initEnhancedFeatures,
  applyMobileReaderImmersive,
  renderBookmarks,
  restoreSavedMarks,
  showReadingEstimate,
  endReadingSession,
  cleanupEnhancedFeatures,
  hideSelectionToolbar,
  addBookmark,
  deleteBookmark,
  formatDate,
  toggleFullscreen,
  closeReader,
  navigatePage,
  handleHighlight,
  openQuickThought,
  toggleToc,
  getImmersiveMode: () => immersiveMode,
  addThought,
  rerenderReaderForCurrentSize
});
const {
  loadReaderEnhancementsModule,
  ensureReaderShareModuleReady,
  ensureReaderAnnotationToolbarModuleReady,
  invokeReaderAnnotationToolbar,
  getReaderAnnotationToolbarModuleApi,
  invokeReaderControlsPanel,
  ensureReaderSettingsModuleReady,
  invokeReaderSettings,
  getReaderSettingsModuleApi,
  ensureReaderTocSearchModuleReady,
  getReaderTocSearchModuleApi,
  ensureReaderTocModuleReady,
  getReaderTocModuleApi,
  ensureReaderProgressModuleReady,
  getReaderProgressModuleApi,
  ensureReaderLifecycleModuleReady,
  getReaderLifecycleModuleApi,
  ensureReaderBookmarksModuleReady,
  getReaderBookmarksModuleApi,
  ensureReaderKeyboardModuleReady,
  getReaderKeyboardModuleApi,
  ensureReaderDisplayModeModuleReady,
  getReaderDisplayModeModuleApi,
  ensureReaderUiPanelsModuleReady,
  getReaderUiPanelsModuleApi,
  ensureReaderRenderSizingModuleReady,
  getReaderRenderSizingModuleApi,
  ensureReaderStatsModuleReady,
  getReaderStatsModuleApi,
  ensureReaderQuickThoughtModuleReady,
  getReaderQuickThoughtModuleApi,
  ensureReaderImmersiveModuleReady,
  getReaderImmersiveModuleApi
} = readerDomainRuntime;

readerUiActions = createReaderUiActionFacade({
  ensureReaderStatsModuleReady,
  getReaderStatsModuleApi,
  ensureReaderImmersiveModuleReady,
  getReaderImmersiveModuleApi,
  ensureReaderDisplayModeModuleReady,
  getReaderDisplayModeModuleApi,
  ensureReaderQuickThoughtModuleReady,
  getReaderQuickThoughtModuleApi,
  ensureReaderRenderSizingModuleReady,
  getReaderRenderSizingModuleApi,
  waitForStableElementSizeFallback,
  ensureReaderKeyboardModuleReady,
  getReaderKeyboardModuleApi,
  elements,
  closeModal,
  ensureReaderBookmarksModuleReady,
  getReaderBookmarksModuleApi,
  ensureReaderShareModuleReady,
  showToast
});

const readerAnnotationToolbarBridge = createReaderAnnotationToolbarBridge({
  ensureReaderAnnotationToolbarModuleReady,
  invokeReaderAnnotationToolbar,
  getReaderAnnotationToolbarModuleApi,
  showToast
});

const readerSettingsBridge = createReaderSettingsBridge({
  getReaderSettingsModuleApi,
  invokeReaderSettings
});

const coreUiRuntime = createCoreUiRuntime({
  importWithChunkRecovery,
  state,
  elements,
  getThoughtsCallbacks,
  getRenderThoughtsView: () => renderThoughtsView,
  openModal,
  closeModal,
  showToast,
  addThought,
  updateThought,
  formatDate,
  addEssay,
  updateEssay,
  deleteEssay,
  syncModalOverlayTheme,
  getActiveCategoryEditMenuCleanup: () => activeCategoryEditMenuCleanup,
  clearActiveCategoryEditMenuCleanup: () => {
    activeCategoryEditMenuCleanup = null;
  },
  deleteBook,
  removeBooksFromAllCollections,
  removeBooksFromAllBooklists,
  renderBookshelf,
  showEditCollectionMenu,
  showAddCollectionModal,
  showAllCollectionsModal,
  showBookDetail,
  toggleBookSelection,
  openBook,
  enterSelectMode,
  saveCollections,
  saveGlobalShelfOrder,
  renderCollectionFilters,
  updateBooksOrder,
  switchView,
  setupBookshelfDelegatedEvents,
  exitSelectMode,
  setViewMode,
  renderBooklistView,
  syncUnifiedSearchUi,
  handlePrimaryActionClick,
  handleFileSelect,
  toggleSiteTheme,
  setupSiteThemeLongPressFullscreen,
  toggleSortMenu,
  handleSort,
  updateWelcomeMessage,
  handleSearch,
  clearSearch,
  openThoughtModal,
  createNewEssay,
  deleteCurrentEssay,
  handleEssayTitleChange,
  toggleEssaysSidebar,
  closeReader,
  navigatePage,
  handleHighlight,
  openQuickThought,
  toggleToc,
  setupSelectionToolbar,
  ensureReaderDisplayModeModuleReady,
  ensureReaderUiPanelsModuleReady,
  ensureReaderRenderSizingModuleReady,
  ensureReaderQuickThoughtModuleReady,
  handleTocSearch,
  clearTocSearch,
  togglePanel,
  toggleFullscreen,
  changeFontSize,
  changeLineHeight,
  changeFontFamily,
  changeTheme,
  setupReaderOverlayOutsideCloseEvents,
  ensureReaderKeyboardModuleReady,
  handleKeyboard,
  handleDrop,
  deleteSelectedBooks,
  showBatchCategoryModal,
  showBatchCollectionModal,
  bindAiLazyEntrypoints,
  setupEnhancedReaderEvents,
  syncThoughtsScrollbarGutter
});
const {
  ensureThoughtsModuleReady,
  getThoughtsModuleApi,
  isThoughtsModuleEventsBound,
  ensureThoughtModalModuleReady,
  getThoughtModalModuleApi,
  ensureEssaysEditorModuleReady,
  getEssaysEditorModuleApi,
  ensureModalCoreModuleReady,
  getModalCoreModuleApi,
  ensureBookDeleteModalModuleReady,
  getBookDeleteModalModuleApi,
  ensureMapLocationBridgeModuleReady,
  ensureThoughtsMobileSidebarModuleReady,
  getThoughtsMobileSidebarModuleApi,
  ensureBookshelfInteractionsModuleReady,
  getBookshelfInteractionsModuleApi,
  ensureAppEventBindingsModuleReady,
  getAppEventBindingsModuleApi
} = coreUiRuntime;

coreUiActions = createCoreUiActionFacade({
  ensureAppEventBindingsModuleReady,
  getAppEventBindingsModuleApi,
  ensureBookshelfInteractionsModuleReady,
  getBookshelfInteractionsModuleApi,
  ensureThoughtModalModuleReady,
  getThoughtModalModuleApi,
  ensureEssaysEditorModuleReady,
  getEssaysEditorModuleApi,
  ensureModalCoreModuleReady,
  getModalCoreModuleApi,
  ensureBookDeleteModalModuleReady,
  getBookDeleteModalModuleApi,
  ensureThoughtsMobileSidebarModuleReady,
  getThoughtsMobileSidebarModuleApi,
  getCurrentView: () => state.currentView,
  showToast
});

const shelfUiDomainRuntime = createShelfUiDomainRuntime({
  importWithChunkRecovery,
  state,
  elements,
  showToast,
  escapeHtml,
  exitSelectMode,
  syncUnifiedSearchUi,
  renderCurrentView,
  ensureThoughtsModuleReady,
  renderThoughtsView,
  ensureHighlightsModuleReady,
  renderHighlights,
  ensureBooklistModuleReady,
  renderBooklistView,
  showManageBooklistBooksModal,
  showAddBooklistModal,
  canAccessFeature,
  isAdmin,
  openMembershipCenter,
  showEditCategoryMenu,
  showAllCategoriesModal,
  showAddCategoryModal,
  renderBookshelf,
  showEditCollectionMenu,
  showAllCollectionsModal,
  showAddCollectionModal,
  sortCollections,
  openModal,
  closeModal,
  deleteBook,
  removeBooksFromAllCollections,
  removeBooksFromAllBooklists,
  updateBook,
  saveCategories,
  renderCategoryFilters,
  openBook
});
const {
  ensureViewNavigationModuleReady,
  getViewNavigationModuleApi,
  ensureCategoryCollectionFiltersModuleReady,
  getCategoryCollectionFiltersModuleApi,
  ensureBatchSelectionModuleReady,
  getBatchSelectionModuleApi,
  ensureShelfViewModeModuleReady,
  getShelfViewModeModuleApi,
  ensureFormatPopoverModuleReady,
  getFormatPopoverModuleApi,
  ensureShelfSearchModuleReady,
  getShelfSearchModuleApi,
  ensureShelfDashboardModuleReady,
  getShelfDashboardModuleApi
} = shelfUiDomainRuntime;

shelfUiActions = createShelfUiActionFacade({
  ensureViewNavigationModuleReady,
  getViewNavigationModuleApi,
  ensureShelfViewModeModuleReady,
  getShelfViewModeModuleApi,
  ensureFormatPopoverModuleReady,
  getFormatPopoverModuleApi,
  ensureCategoryCollectionFiltersModuleReady,
  getCategoryCollectionFiltersModuleApi,
  ensureShelfSearchModuleReady,
  getShelfSearchModuleApi,
  ensureBatchSelectionModuleReady,
  getBatchSelectionModuleApi,
  ensureShelfDashboardModuleReady,
  getShelfDashboardModuleApi,
  showToast
});

shelfOrchestrator = createShelfOrchestrator({
  state,
  loadCategoriesFromStorage,
  saveCategoriesToStorage,
  loadCollectionsFromStorage,
  saveCollectionsToStorage,
  loadBooklistsFromStorage,
  saveBooklistsToStorage,
  loadGlobalShelfOrderFromStorage,
  saveGlobalShelfOrderToStorage,
  updateGlobalShelfOrderForCollectionOrderInStorage,
  generateCollectionIdValue,
  generateBooklistIdValue,
  removeBooksFromAllCollectionsFromModule,
  removeBooksFromAllBooklistsFromModule,
  addBooksToCollectionFromModule
});

const aiOrchestrator = createAiOrchestrator({
  elements,
  getAiModuleApi,
  ensureAiModuleReady,
  showToast,
  canAccessFeature,
  openMembershipCenter
});

const musicOrchestrator = createMusicOrchestrator({
  state,
  ensureMusicPlayerReady,
  showToast
});

const settingsOrchestrator = createSettingsOrchestrator({
  getSiteThemeModuleApi,
  ensureSiteThemeModuleReady,
  getSiteThemeFullscreenModuleApi,
  ensureSiteThemeFullscreenModuleReady
});

const readerOrchestrator = createReaderOrchestrator({
  elements,
  getReaderLifecycleModuleApi,
  ensureReaderLifecycleModuleReady,
  getReaderProgressModuleApi,
  ensureReaderProgressModuleReady,
  getReaderTocModuleApi,
  ensureReaderTocModuleReady,
  getReaderTocSearchModuleApi,
  ensureReaderTocSearchModuleReady,
  getReaderUiPanelsModuleApi,
  bindReaderOverlayOutsideCloseFallback: bindReaderOverlayOutsideCloseFallbackFromModule,
  togglePanelFallback,
  closeAllPanelsFallback,
  clearTocSearchFallback,
  toggleTocFallback,
  showToast
});

// ========================================
// 初始化
// ========================================
async function init() {
  await initAppLifecycle({
    initDB,
    loadAllData,
    ensureShelfViewModeModuleReady,
    loadShelfViewMode,
    ensureSiteThemeModuleReady,
    ensureReaderSettingsModuleReady,
    ensureReaderProgressModuleReady,
    ensureReaderStatsModuleReady,
    ensureReaderImmersiveModuleReady,
    ensureFormatPopoverModuleReady,
    ensureShelfSearchModuleReady,
    ensureShelfDashboardModuleReady,
    loadReaderSettings,
    loadReadingStats,
    setupEventListeners,
    setupFormatEvents,
    setupCategoryEvents,
    setupWindowControlsOverlay,
    renderCurrentView,
    updateWelcomeMessage,
    initPageScrollbar,
    triggerChunkLoadRecovery,
    showToast
  });
  try {
    await initMembershipModule({
      state,
      elements,
      showToast,
      switchView
    });
  } catch (error) {
    showToast('会员系统初始化失败，已降级为 Free 访客模式');
  }
  try {
    initAdminDashboardModule({
      state,
      elements,
      showToast,
      switchView
    });
  } catch (error) {
    showToast('管理台模块初始化失败');
  }
}

async function loadAllData() {
  return loadAllDataForApp({
    state,
    getAllBooks,
    getAllThoughts,
    getAllHighlights,
    getAllEssays,
    getAllBookmarks,
    loadCategories,
    loadCollections,
    loadGlobalShelfOrder,
    loadBooklists,
    getAllMusic,
    getAllPodcasts
  });
}

const VIEW_RENDER_CACHE = {
  signatures: {
    shelf: '',
    thoughts: '',
    highlights: '',
    essays: ''
  },
  rendered: {
    shelf: false,
    thoughts: false,
    highlights: false,
    essays: false
  }
};

function foldHash(seed, value) {
  const text = String(value ?? '');
  let hash = seed >>> 0;
  for (let i = 0; i < text.length; i += 1) {
    hash ^= text.charCodeAt(i);
    hash = Math.imul(hash, 16777619) >>> 0;
  }
  return hash >>> 0;
}

function digestList(list, pick) {
  let hash = 2166136261 >>> 0;
  if (!Array.isArray(list)) return hash;
  for (let i = 0; i < list.length; i += 1) {
    const token = typeof pick === 'function' ? pick(list[i], i) : list[i];
    hash = foldHash(hash, token);
  }
  return hash >>> 0;
}

function digestMembershipMap(mapObj) {
  let hash = 2166136261 >>> 0;
  if (!mapObj || typeof mapObj !== 'object') return hash;
  const keys = Object.keys(mapObj).sort();
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    hash = foldHash(hash, key);
    const arr = Array.isArray(mapObj[key]) ? mapObj[key] : [];
    hash = foldHash(hash, arr.length);
    for (let j = 0; j < arr.length; j += 1) {
      hash = foldHash(hash, arr[j]);
    }
  }
  return hash >>> 0;
}

function buildViewRenderSignature(viewName) {
  switch (viewName) {
    case 'shelf': {
      let hash = 2166136261 >>> 0;
      hash = foldHash(hash, state.isGridView ? 1 : 0);
      hash = foldHash(hash, state.searchQuery || '');
      hash = foldHash(hash, state.sortBy || '');
      hash = foldHash(hash, state.filterFormat || '');
      hash = foldHash(hash, state.filterCategory || '');
      hash = foldHash(hash, state.filterCollection || '');
      hash = foldHash(hash, state.shelfQuickFilter || '');
      hash = foldHash(hash, state.isSelectMode ? 1 : 0);
      hash = foldHash(hash, state.selectedBooks?.size || 0);
      hash = foldHash(hash, state.books.length);
      hash = foldHash(hash, digestList(state.books, (book) => [
        book?.id || '',
        book?.updatedAt || '',
        book?.lastReadAt || '',
        book?.progress || 0,
        book?.category || '',
        book?.format || '',
        (book?.title || '').length,
        (book?.author || '').length
      ].join('|')));
      hash = foldHash(hash, digestList(state.collections, (c) => [
        c?.id || '',
        c?.name || '',
        c?.updatedAt || ''
      ].join('|')));
      hash = foldHash(hash, digestList(state.categories, (c) => c || ''));
      hash = foldHash(hash, digestList(state.globalShelfOrder, (id) => id || ''));
      hash = foldHash(hash, digestMembershipMap(state.collectionMembership));
      return `shelf:${hash.toString(36)}`;
    }
    case 'thoughts': {
      let hash = 2166136261 >>> 0;
      hash = foldHash(hash, state.thoughts.length);
      hash = foldHash(hash, digestList(state.thoughts, (t) => [
        t?.id || '',
        t?.updatedAt || '',
        t?.createdAt || '',
        (t?.content || '').length,
        Array.isArray(t?.tags) ? t.tags.length : 0,
        Array.isArray(t?.images) ? t.images.length : 0,
        Array.isArray(t?.videos) ? t.videos.length : 0,
        Array.isArray(t?.audios) ? t.audios.length : 0,
        Array.isArray(t?.references) ? t.references.length : 0
      ].join('|')));
      return `thoughts:${hash.toString(36)}`;
    }
    case 'highlights': {
      let hash = 2166136261 >>> 0;
      hash = foldHash(hash, state.highlightSearch || '');
      hash = foldHash(hash, state.highlightGrouped ? 1 : 0);
      hash = foldHash(hash, state.highlightGroupLayout || 'list');
      hash = foldHash(hash, state.highlightColorFilter || 'all');
      hash = foldHash(hash, state.highlightSortBy || 'createdAt');
      hash = foldHash(hash, state.highlights.length);
      hash = foldHash(hash, digestList(state.highlights, (h) => [
        h?.id || '',
        h?.updatedAt || '',
        h?.createdAt || '',
        h?.color || '',
        (h?.text || '').length,
        (h?.note || '').length,
        h?.bookId || ''
      ].join('|')));
      return `highlights:${hash.toString(36)}`;
    }
    case 'essays': {
      let hash = 2166136261 >>> 0;
      hash = foldHash(hash, state.essays.length);
      hash = foldHash(hash, digestList(state.essays, (essay) => [
        essay?.id || '',
        essay?.updatedAt || '',
        essay?.createdAt || '',
        (essay?.title || '').length,
        Array.isArray(essay?.blocks) ? essay.blocks.length : 0
      ].join('|')));
      return `essays:${hash.toString(36)}`;
    }
    default:
      return null;
  }
}

function isViewRenderCacheReady(viewName) {
  if (viewName === 'shelf') return true;
  if (viewName === 'thoughts') {
    return !!getThoughtsModuleApi?.() && !!isThoughtsModuleEventsBound?.();
  }
  if (viewName === 'highlights') {
    return !!getHighlightsModuleApi?.() && !!isHighlightsModuleEventsBound?.();
  }
  if (viewName === 'essays') {
    return !!getEssaysEditorModuleApi?.()?.renderEssays;
  }
  return false;
}

function shouldSkipCurrentViewRender(viewName) {
  const signature = buildViewRenderSignature(viewName);
  if (!signature) return false;
  if (!isViewRenderCacheReady(viewName)) return false;
  if (!VIEW_RENDER_CACHE.rendered[viewName]) return false;
  return VIEW_RENDER_CACHE.signatures[viewName] === signature;
}

function markCurrentViewRendered(viewName) {
  const signature = buildViewRenderSignature(viewName);
  if (!signature) return;
  if (!isViewRenderCacheReady(viewName)) return;
  VIEW_RENDER_CACHE.rendered[viewName] = true;
  VIEW_RENDER_CACHE.signatures[viewName] = signature;
}

// ========================================
// 增强阅读器事件监听
// ========================================

function renderCurrentView() {
  const viewName = state.currentView;
  if (shouldSkipCurrentViewRender(viewName)) {
    return;
  }

  renderCurrentViewByName(state.currentView, {
    renderBookshelf,
    renderBooklistView,
    renderThoughtsView,
    renderHighlights,
    renderEssays,
    renderMusic,
    renderAdmin
  });

  markCurrentViewRendered(viewName);
}

function renderBooklistView() {
  renderBooklistViewWithLazyInit({
    booklistModuleApi: getBooklistModuleApi(),
    ensureBooklistModuleReady,
    rerender: renderBooklistView,
    showToast
  });
}

// ========================================
// 书单模块已拆分至 features/booklistModule.js
// ========================================

// ========================================
// 音乐模块已拆分至 features/musicModule.js
// ========================================

// 渲染思索视图的包装函数
function renderThoughtsView() {
  renderThoughtsViewWithLazyInit({
    state,
    elements,
    thoughtsModuleApi: getThoughtsModuleApi(),
    thoughtsModuleEventsBound: isThoughtsModuleEventsBound(),
    ensureThoughtsModuleReady,
    rerender: renderThoughtsView,
    getThoughtsCallbacks,
    syncThoughtsScrollbarGutter,
    showToast
  });
}

// ========================================
// 书架渲染
// ========================================
function renderBookshelf() {
  renderBookshelfViewFromModule({
    state,
    elements,
    updateWelcomeMessage,
    updateShelfStats,
    updateRecentTimeline,
    updateFormatFilters,
    renderCategoryFilters,
    filterBooks,
    sortBooks,
    buildMixedShelfItems: buildMixedShelfItemsHelper,
    createCollectionCardHtml,
    createCollectionListItemHtml,
    createBookCard,
    createBookListItem,
    getFilteredCollectionsForShelf,
    buildCollectionShelfHeaderHtml,
    updateBookshelfDragState
  });
}

// ========================================
// 格式筛选 Popover
// ========================================
// ========================================
// 分类筛选
// ========================================
// 分类/书单/合集管理模块已拆分至 features/libraryModalsModule.js

// ========================================
// 欢迎语和阅读统计
// ========================================

// 排序
function handleSort(sortBy) {
  handleSortByWithUi({
    sortBy,
    state,
    elements,
    renderCurrentView,
    showToast
  });
}

// 书籍详情模块已拆分至 features/bookDetailModule.js

// ========================================
// 批量选择功能
// ========================================
// ========================================
// 文件处理（按需加载）
// ========================================
// 文件导入模块已拆分至 features/fileImportModule.js

// ========================================
// 阅读器
// ========================================
// 快速记录思索（不离开阅读页面）

// ========================================
// 阅读器标注/工具栏模块（按需加载）
// ========================================
function renderHighlights() {
  renderHighlightsViewWithLazyInit({
    state,
    highlightsModuleApi: getHighlightsModuleApi(),
    highlightsModuleEventsBound: isHighlightsModuleEventsBound(),
    ensureHighlightsModuleReady,
    rerender: renderHighlights,
    showToast
  });
}

// ========================================
// 涂鸦模块已拆分至 features/highlightsModule.js
// ========================================

// ========================================
// 思索
// ========================================
// 随笔 - Notion 风格

// ========================================
// 增强功能初始化和清理
// ========================================

// 窗口大小变化处理器
let uiVisibilityHandler = null;

async function initEnhancedFeatures() {
  const refs = await initEnhancedFeaturesLifecycle({
    state,
    elements,
    showToast,
    navigatePage,
    changeFontSize,
    changeTheme,
    initResizeHandler,
    bindIframeSelectionEvents,
    rerenderReaderForCurrentSize,
    loadReaderEnhancementsModule,
    uiVisibilityHandler
  });

  autoScroll = refs.autoScroll;
  tts = refs.tts;
  readingTimer = refs.readingTimer;
  textSearch = refs.textSearch;
  gestures = refs.gestures;
  immersiveMode = refs.immersiveMode;
  autoNightMode = refs.autoNightMode;
  uiVisibilityHandler = refs.uiVisibilityHandler;
}

function cleanupEnhancedFeatures() {
  const refs = cleanupEnhancedFeaturesLifecycle({
    autoScroll,
    tts,
    readingTimer,
    textSearch,
    gestures,
    immersiveMode,
    autoNightMode,
    elements,
    uiVisibilityHandler,
    cleanupResizeHandler
  });

  autoScroll = refs.autoScroll;
  tts = refs.tts;
  readingTimer = refs.readingTimer;
  textSearch = refs.textSearch;
  gestures = refs.gestures;
  immersiveMode = refs.immersiveMode;
  autoNightMode = refs.autoNightMode;
  uiVisibilityHandler = refs.uiVisibilityHandler;
}

// ========================================
// 书签功能
// ========================================

// ========================================
// 阅读进度预估 - 已禁用
// ========================================

// ========================================
// 分享功能
// ========================================
// ========================================
// 删除确认
// ========================================

// ========================================
// 工具函数
// ========================================

// ========================================
// 键盘快捷键
// ========================================

let appStarted = false;

function scheduleLowPriorityWarmup(callback, timeout = 1200) {
  if (typeof callback !== 'function') return;
  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(() => callback(), { timeout });
    return;
  }
  setTimeout(() => callback(), 800);
}

export function startApp() {
  if (appStarted) return;
  appStarted = true;

  // 初始化拖拽
  initModalDrag();

  // 暴露给全局
  window.closeModal = closeModal;
  window.confirmDeleteBook = confirmDeleteBook;
  window.openBook = openBook;
  ensureMapLocationBridgeModuleReady().catch(() => {});

  // 启动应用
  installChunkLoadRecoveryHandlers();
  init();
  initThoughtsMobileSidebarToggleBridge();

  // 低优先级预热高频重模块，减少首次切换卡顿
  scheduleLowPriorityWarmup(() => {
    ensureThoughtsModuleReady().catch(() => {});
  }, 1800);
}

// ========================================
// AI 助手模块已拆分至 features/aiModule.js
// ========================================
